<script setup lang="ts">
import type { ComposedPageMeta } from '@xcel-next/composer-schema'
import type { QuoteParagraph } from '../../utils/paragraph-schema/paragraphs'

const props = defineProps<{
  quote?: QuoteParagraph['quote'],
  pageMeta?: ComposedPageMeta
}>()
</script>

<template v-if="quote?.text?.length > 0">
  <div :class="['bx-content', 'bx-typo--content-quote', pageMeta?.style === 'tvm-epg' && 'bx-epg-quote bx-typo--vod-epg']">
    <div class="bx-content__quote-text">
      &bdquo;{{ quote?.text }}&ldquo;
    </div>
    <div v-if="quote?.author"
         class="bx-content__quote-author">
      {{ quote?.author }}
    </div>
  </div>
</template>
